import React from 'react';
import './LiveChronik.css';
import { useTranslation } from '../../context/LanguageContext';

/**
 * Live-Chronik - Zeigt die letzten Pakete
 * Mit Statistik "Heute erfasst"
 */
const LiveChronik = ({ packages = [], paketeHeuteCount = 0 }) => {
  const { t } = useTranslation();
  
  if (packages.length === 0) {
    return (
      <div className="live-chronik empty">
        <h3>📋 {t('vrMenu.lastPackages')}</h3>
        <p>{t('vrMenu.noPackagesYet')}</p>
      </div>
    );
  }

  return (
    <div className="live-chronik">
      <h3>📋 {t('vrMenu.lastPackages')} / {t('vrMenu.todaysCaptured')} {paketeHeuteCount}</h3>
      <div className="chronik-list">
        {packages.map((pkg, index) => {
          // Baue kompakte Zeile: Name • Straße Hausnr. • Regal • [Gewicht] [Dienst]
          const parts = [];
          
          // Name (Quest: name, Alt: empfaenger)
          const name = pkg.name || pkg.empfaenger;
          if (name) parts.push(name);
          
          // Straße + Hausnummer (Quest: streetAndNumber, Alt: strasse + hausnummer)
          const address = pkg.streetAndNumber || 
                          (pkg.strasse && pkg.hausnummer ? `${pkg.strasse} ${pkg.hausnummer}` : null) ||
                          pkg.strasse || 
                          (pkg.hausnummer ? `Hausnr. ${pkg.hausnummer}` : null);
          if (address) parts.push(address);
          
          // Regalplatz
          if (pkg.regalplatz) parts.push(`📦 ${pkg.regalplatz}`);
          
          // Optional: Gewicht (auf ganze kg runden)
          if (pkg.gewicht) {
            // Extrahiere Zahl aus "3.000 kg" oder "3,5 kg"
            const gewichtMatch = pkg.gewicht.match(/(\d+[.,]?\d*)/);
            if (gewichtMatch) {
              const gewichtNum = parseFloat(gewichtMatch[1].replace(',', '.'));
              const gewichtGerundet = Math.round(gewichtNum); // 3.000 → 3, 3.5 → 4, 3.232 → 3
              parts.push(`${gewichtGerundet} kg`);
            } else {
              parts.push(pkg.gewicht); // Fallback wenn Format unbekannt
            }
          }
          
          // ✅ Paketfarbe separat speichern (nicht zu parts hinzufügen)
          const paketFarbe = pkg.paketFarbe || null;
          
          // ✅ Uhrzeit extrahieren (timestamp oder datum)
          const dateString = pkg.timestamp || pkg.datum;
          let uhrzeit = '??:??';
          if (dateString) {
            try {
              const date = new Date(dateString);
              uhrzeit = date.toLocaleTimeString('de-DE', { 
                hour: '2-digit', 
                minute: '2-digit' 
              });
            } catch (e) {
              console.warn('Ungültiges Datum:', dateString);
            }
          }
          
          const infoText = parts.join(' • ');
          
          // ✅ Deutsche Farbnamen zu CSS konvertieren
          const getCssColor = (farbe) => {
            const farbeLower = farbe.toLowerCase();
            const colorMap = {
              'weiß': '#FFFFFF',
              'weiss': '#FFFFFF',
              'white': '#FFFFFF',
              'schwarz': '#000000',
              'black': '#000000',
              'rot': '#FF0000',
              'red': '#FF0000',
              'blau': '#0000FF',
              'blue': '#0000FF',
              'grün': '#00FF00',
              'gruen': '#00FF00',
              'green': '#00FF00',
              'gelb': '#FFFF00',
              'yellow': '#FFFF00',
              'orange': '#FFA500',
              'braun': '#8B4513',
              'brown': '#8B4513',
              'grau': '#808080',
              'gray': '#808080',
              'grey': '#808080',
              'lila': '#800080',
              'purple': '#800080',
              'rosa': '#FFC0CB',
              'pink': '#FFC0CB'
            };
            return colorMap[farbeLower] || farbeLower;
          };

          return (
            <div key={index} className="chronik-item">
              <div className="chronik-check">✓</div>
              <div className="chronik-info">
                <div className="chronik-compact">
                  <span style={{ color: '#4CAF50', fontWeight: 'bold', marginRight: '8px' }}>
                    {uhrzeit}
                  </span>
                  {infoText}
                  {paketFarbe && (
                    <>
                      {' • '}
                      <span style={{
                        display: 'inline-block',
                        width: '12px',
                        height: '12px',
                        borderRadius: '50%',
                        backgroundColor: getCssColor(paketFarbe),
                        border: paketFarbe.toLowerCase() === 'weiß' || paketFarbe.toLowerCase() === 'weiss' || paketFarbe.toLowerCase() === 'white' 
                          ? '2px solid #666' 
                          : 'none',
                        verticalAlign: 'middle',
                        boxShadow: '0 1px 3px rgba(0,0,0,0.3)'
                      }}></span>
                    </>
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default LiveChronik;
